import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = props => (
  <div className={props.modalBodyClass}>
    <div className="content-wrap">
      <div className="content">
        { props.children }
      </div>
    </div>
  </div>
);

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  modalBodyClass: PropTypes.string,
};

ModalBody.defaultProps = {
  modalBodyClass: 'modal-body',
};

export default ModalBody;



// WEBPACK FOOTER //
// ./src-react/Modals/components/ModalBody/index.jsx